import React from 'react';

import { AppFormattedMessage } from '../app-formatted-message/index';
import LineDelimiter from '../line-delimiter/index';

const OrDelimiter = () => {
  return (
    <div className="flex items-center gap-4">
      <LineDelimiter />
      <div className="select-none font-inter text-label-md font-[550] text-gray-300">
        <AppFormattedMessage id="OR" />
      </div>
      <LineDelimiter />
    </div>
  );
};

export default OrDelimiter;
